import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { map } from 'rxjs/operators';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private authSvc: AuthService,
              private router: Router ){}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> |
    Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.authSvc.userData$.pipe(
      map(user => {
        if (!user) {
          Swal.fire({
            title: 'Debe iniciar sesión para ir al carrito',
            text: 'Click en el botón ingresar',
            icon: 'question',
            allowOutsideClick: false,
            showCloseButton: true
          });
          this.router.navigate(['/catalogo']);
          return false;
        }
        return true;
      })
    );
  }
}
